/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from './successpage.component.scss.ngstyle';
import * as import1 from '@angular/core';
import * as import2 from '../../shared/decorator/header/header.component.ngfactory';
import * as import3 from '../../../../app/shared/decorator/header/header.component';
import * as import4 from '@angular/common';
import * as import5 from '../../shared/menu/menu.component.ngfactory';
import * as import6 from '../../../../app/shared/menu/menu.component';
import * as import7 from '../../../../modules/transfer-state/transfer-state';
import * as import8 from '../../../../../common/utils/costguideutils';
import * as import9 from '../../../../app/lead-form/successpage/successpage.component';
import * as import10 from '@angular/router';
const styles_SuccessPageComponent:any[] = [import0.styles];
export const RenderType_SuccessPageComponent:import1.RendererType2 = import1.ɵcrt({
  encapsulation: 2,
  styles: styles_SuccessPageComponent,
  data: {}
}
);
function View_SuccessPageComponent_1(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'i',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Our trusted partners will match you with Top-Rated Local Professionals for your project.']))
  ]
  ,(null as any),(null as any));
}
function View_SuccessPageComponent_2(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'i',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['Our trusted partners will match you.']))
  ]
  ,(null as any),(null as any));
}
export function View_SuccessPageComponent_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'header',([] as any[]),(null as any),(null as any),(null as any),import2.View_HeaderComponent_0,import2.RenderType_HeaderComponent)),
    import1.ɵdid(49152,(null as any),0,import3.HeaderComponent,([] as any[]),(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n\n'])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),45,'div',[
      [
        'class',
        'menu-perspective effect-moveright'
      ]
      ,
      [
        'id',
        'menu-perspective'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n  '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),39,'div',[[
        'class',
        'menu-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n    '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),36,'div',[[
        'class',
        'menu-wrapper'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n\n      '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),33,'div',[[
        'class',
        'row'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n        '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),30,'div',[[
        'class',
        'gratitude-container'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n          '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),27,'div',[[
        'class',
        'gratitude'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['THANK YOU'])),
    (l()(),import1.ɵted((null as any),['\n            '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),9,'div',[[
        'style',
        'width:250px;margin:auto;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'style',
        'display:inline-block;width: 40px;height:1px;background:#000;vertical-align: 5px;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n               '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (l()(),import1.ɵeld(0,(null as any),(null as any),1,'i',[[
        'style',
        'font-size:20px;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['for your free'])),
    (l()(),import1.ɵted((null as any),[' \n              '])),
      (l()(),import1.ɵeld(0,(null as any),(null as any),0,'div',[[
        'style',
        'display:inline-block;width: 40px;height:1px;background:#000;vertical-align: 5px;'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'h1',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['REQUEST'])),
    (l()(),import1.ɵted((null as any),['\n\n            '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),7,'p',[
      [
        'id',
        'trusted_partners_copy'
      ]
      ,
      [
        'style',
        'margin-top:30px;'
      ]

    ]
    ,(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuccessPageComponent_1)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n              '])),
    (l()(),import1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SuccessPageComponent_2)),
    import1.ɵdid(16384,(null as any),0,import4.NgIf,[
      import1.ViewContainerRef,
      import1.TemplateRef
    ]
      ,{ngIf: [
        0,
        'ngIf'
      ]
    },(null as any)),
    (l()(),import1.ɵted((null as any),['\n            '])),
    (l()(),import1.ɵted((null as any),['\n\n          '])),
    (l()(),import1.ɵted((null as any),['\n        '])),
    (l()(),import1.ɵted((null as any),['\n      '])),
    (l()(),import1.ɵted((null as any),['\n\n    '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵted((null as any),['\n  '])),
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'menu',([] as any[]),(null as any),(null as any),(null as any),import5.View_MenuComponent_0,import5.RenderType_MenuComponent)),
    import1.ɵdid(4243456,(null as any),0,import6.MenuComponent,[
      'isBrowser',
      import7.TransferState,
      import8.CostGuideUtils
    ]
    ,(null as any),(null as any)),
    (l()(),import1.ɵted((null as any),['\n'])),
    (l()(),import1.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    var co:import9.SuccessPageComponent = v.component;
    const currVal_0:any = (co.verticalType == 1);
    ck(v,35,0,currVal_0);
    const currVal_1:any = (co.verticalType == 2);
    ck(v,38,0,currVal_1);
  },(null as any));
}
function View_SuccessPageComponent_Host_0(l:any):import1.ɵViewDefinition {
  return import1.ɵvid(0,[
    (l()(),import1.ɵeld(0,(null as any),(null as any),1,'successPageComponent',([] as any[]),(null as any),(null as any),(null as any),View_SuccessPageComponent_0,RenderType_SuccessPageComponent)),
    import1.ɵdid(49152,(null as any),0,import9.SuccessPageComponent,[import10.ActivatedRoute],(null as any),(null as any))
  ]
  ,(null as any),(null as any));
}
export const SuccessPageComponentNgFactory:import1.ComponentFactory<import9.SuccessPageComponent> = import1.ɵccf('successPageComponent',import9.SuccessPageComponent,View_SuccessPageComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./src/ngfactory/app/lead-form/successpage/successpage.component.ngfactory.ts